import toast from "react-hot-toast";
import { LEVELNAME } from "./constants";

export const countQuestionsByLevelFn = (numberQuestions, level) => {
    const quizList = Array.from({ length: numberQuestions });
    let quizModelList;
    if (level !== LEVELNAME.STANDARD) {
        quizModelList = quizList.map(() => {
            return { level };
        });
    }
    if (level === LEVELNAME.STANDARD) {
        const numberQuestionsByLevel = numberQuestions / 3;
        quizModelList = quizList.map((_, i) => {
            if (i < numberQuestionsByLevel) {
                return { level: LEVELNAME.ELEMENTARY };
            }
            if (i >= numberQuestionsByLevel * 2) {
                return { level: LEVELNAME.HARD };
            }
            return { level: LEVELNAME.MEDIUM };
        });
    }
    return quizModelList;
};


// Funzione esistente per ottenere domande casuali
export const getRandomQuestions = (allQuestions, numberQuestions) => {

    if (allQuestions.length <= numberQuestions) {
        return allQuestions;
    }

    const shuffledArray = allQuestions.slice();
    const randomQuestions = [];

    while (randomQuestions.length < numberQuestions && shuffledArray.length > 0) {
        const randomIndex = Math.floor(Math.random() * shuffledArray.length);
        randomQuestions.push(shuffledArray[randomIndex]);
        shuffledArray.splice(randomIndex, 1);
    }

    return randomQuestions;
};

// Funzione modificata per ottenere domande risolte
const getRandomResolvedQuestions = ({ level, quantity, notResolvedQuestions, allQuestions }) => {
    const allQuestionsByLevel = allQuestions.filter(question => question.level === level);
    const resolvedQuestions = allQuestionsByLevel.filter(question => !notResolvedQuestions.some(notResolved => notResolved._id === question._id));

    return getRandomQuestions(resolvedQuestions, quantity);
};

// Nuova funzione per ottenere domande per un livello specifico
const getQuestionsByLevel = (level, quantity, notResolvedQuestions, allQuestions, showMessage) => {
    const questionsByLevel = notResolvedQuestions.filter(question => question.level === level);
    let questions = getRandomQuestions(questionsByLevel, quantity);
    if (questions.length < quantity) {
        const quantityQuestionsForAdd = quantity - questions.length;
        const questionsForAdd = getRandomResolvedQuestions({ level, quantity: quantityQuestionsForAdd, notResolvedQuestions, allQuestions });

        // Mostra il toast solo se non è già stato mostrato
        if (!showMessage?.isShowed) {
            toast(showMessage?.message, {
                icon: '⚠️',
                duration: 5000,
            });
            showMessage.isShowed = true; // Evita di mostrare il toast di nuovo
        }

        questions = [...questions, ...questionsForAdd];
    }
    return questions;
};

// Funzione esistente modificata per ottenere compiti casuali
const getRandomTasks = ({ notResolvedQuestions, quantity, level, allQuestions }) => {

    let randomQuestions = [];

    // Variabile per gestire la visualizzazione del toast
    let showMessage = {
        isShowed: false,
        message: 'Le nuove domande non sono sufficienti. Includeremo alcune domande già risolte.'
    };

    if (level === LEVELNAME.STANDARD) {
        const eachLevelQuantity = quantity / 3;
        const elementaryQuestions = getQuestionsByLevel(LEVELNAME.ELEMENTARY, eachLevelQuantity, notResolvedQuestions, allQuestions, showMessage);
        const mediumQuestions = getQuestionsByLevel(LEVELNAME.MEDIUM, eachLevelQuantity, notResolvedQuestions, allQuestions, showMessage);
        const hardQuestions = getQuestionsByLevel(LEVELNAME.HARD, eachLevelQuantity, notResolvedQuestions, allQuestions, showMessage);
        randomQuestions = [...elementaryQuestions, ...mediumQuestions, ...hardQuestions];
    } else {
        randomQuestions = getQuestionsByLevel(level, quantity, notResolvedQuestions, allQuestions, showMessage);
    }

    return randomQuestions;
};


export const createQuizFn = ({ allQuestions, quantity, level, resolvedQuizzes }) => {
    if (!allQuestions || !level || !quantity) {
        return;
    }

    let notResolvedQuestions = allQuestions;
    if (resolvedQuizzes && resolvedQuizzes.length) {
        const resolvedTasks = resolvedQuizzes.flatMap(quiz => quiz.tasks);
        notResolvedQuestions = allQuestions.filter(question =>
            !resolvedTasks.some(resolved => resolved._id === question._id)
        );
    }

    const taskList = getRandomTasks({ notResolvedQuestions, quantity, level, allQuestions });
    return taskList.map(({ _id }) => _id);
};

// export const classroomResolvedQuizzesFn = (classroomList) => {
//     const quizzesForRemove = new Set();

//     classroomList.forEach(classroom => {
//         classroom?.quizList?.forEach(quiz => {
//             if (quiz?.tasks) {
//                 quiz.tasks?.forEach((idTask) => {
//                     quizzesForRemove.add(idTask);
//                 });
//             }
//             classroom?.studentList?.forEach(({ resolvedQuizzes }) => {
//                 const resolvedQuizByStudent = resolvedQuizzes.find(resolvedQuiz => resolvedQuiz.idQuiz === quiz._id);
//                 if (resolvedQuizByStudent) {
//                     resolvedQuizByStudent?.tasks?.forEach(task => {
//                         quizzesForRemove.add(task._id);
//                     });
//                 }
//             });
//         });
//     });

//     return Array.from(quizzesForRemove);
// };

export const createQuizForClassroomFn = ({ allQuestions, quantity, level, classroomList }) => {
    if (!allQuestions || !level || !quantity || !classroomList) {
        return;
    }
    const resolvedTasksByClassroomSet = new Set(classroomList.flatMap(({ usedTaskList }) => usedTaskList));

    const notResolvedQuestions = allQuestions.filter(({ _id }) => !resolvedTasksByClassroomSet.has(_id)
    );

    const taskList = getRandomTasks({ notResolvedQuestions, quantity, level, allQuestions });
    return taskList.map(({ _id }) => _id);
};

// export const createFastQuizForClassroomFn = ({ allQuestions, quantity, level, usedTaskList }) => {
//     if (!(allQuestions || level || quantity || usedTaskList)) {
//         return;
//     }

//     let notResolvedQuestions = allQuestions;

//     if (usedTaskList?.length > 0) {
//         const usedTaskListSet = new Set(usedTaskList);
//         notResolvedQuestions = allQuestions.filter(({ _id }) => !usedTaskListSet.has(_id)
//         );
//     }

//     const taskList = getRandomTasks({ notResolvedQuestions, quantity, level, allQuestions });
//     return taskList.map(({ _id }) => _id);
// }




